import { cartReminderUnsubscribeMessageStyles } from "@insite/content-library/Widgets/CartReminderUnsubscribe/CartReminderUnsubscribeMessage";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import { css } from "styled-components";

Object.assign(cartReminderUnsubscribeMessageStyles, {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    errorText: {
        css: css`
            font-size: ${TYPOGRAPHY.size.smaller};
            line-height: 20px;
            margin-bottom: 10px;
        `,
    },
    unsubscribeMessageText: {
        css: css`
            margin-bottom: 10px;
            font-size: ${TYPOGRAPHY.size.smaller};
            line-height: 20px;
        `,
    },
    unsubscribeDescriptionText: {
        css: css`
            margin-bottom: 10px;
            font-size: ${TYPOGRAPHY.size.smaller};
            line-height: 20px;
        `,
    },
});
